const BASE_URL = "https://psychnow.com";

export const EXTERNAL_URL = {
  USER_GUIDE: `${BASE_URL}/userguide`,
  TERMS: `{BASE_URL}/termsandconditions`,
  PRIVACY_POLICY: `{BASE_URL}/privacypolicy`,
  BAA: `{BASE_URL}/baa`,
  FREE_TRIAL_TERMS: `{BASE_URL}/freetrialtermsandconditions`,
} as const;
